import { Component } from '@angular/core';

@Component({
  selector: 'app-children-deduplication-region',
  templateUrl: './children-deduplication-region.component.html',
  styleUrls: ['./children-deduplication-region.component.scss']
})
export class ChildrenDeduplicationRegionComponent {

}
